import { RefObject, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { scrollTopIframe } from '../utils/iframe';

export const useScrollToTop = (scrollElement?: RefObject<HTMLDivElement>): void => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    try {
      if (scrollElement) {
        scrollTopIframe(scrollElement);
      } else {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, scrollElement]);
};
